import Page from "components/Page";
import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { withTranslation } from "react-i18next";
import styles from "./EditEvent.module.scss";
import "./EditEvent.scss";
import TimePicker from "rc-time-picker";
import { Row, Col } from "reactstrap";
import AddRolesModal from "../AddEvent/components/AddRolesModal";
import moment from "moment";
import {
  notifyAttendeesOptions,
  notifyAttendeesOptionsForAllDayEvent,
} from "../../../constants";
import CustomDropdown from "components/Dropdown";
import CustomInputTag from "../AddEvent/components/CustomInputTag";
import {
  useStaffDesignation,
  useCreateUpdateSchedulerEventMutation,
  useCreateSchedulerEventMutation,
  getEventListDetails,
  useCreateSchedulerEventCheckingAvailabilityMutation,
} from "repositories/scheduler-repository";
import toast from "react-hot-toast";
import Loader from "components/Loader";
import { useParams } from "react-router-dom";
import {
  decodeId,
  getDay,
  testRegexCheck,
  updateTimeToUpcomingQuater,
} from "utils";
import InviteesPopup from "../EventDetails/components/Modals/InviteesPopup";
import { useSelector } from "react-redux";
import SelectStaffMemberModal from "../AddEvent/components/SelectStaffMemberModal";
import RolePopup from "../AddEvent/components/RolePopup";
import SelectOfficeModal from "../AddEvent/components/SelectOfficeModal";
import { addEditEventsConst } from "../AddEvent/addEvents.constants";
import useEventDateTimeSync from "../AddEvent/hooks/useEventDateTimeSync";
import {
  addRemoveUserOrRoleError,
  arrayIntoString,
  getLocalTimeZoneCode,
  hasTimeChanged,
  getRepeatMessage,
  getSelectedDayValueForWeekdayOrWeekend,
  handleChangeValidation,
  handleSubmitValidation,
  matchedBothDatesValues,
  matchedBothPatternValues,
  MoreTagsFunction,
  setterCustomSchduler,
  setterPublishOffices,
} from "../AddEvent/addEvents.functions";
import RepeatEventDropDowns from "../AddEvent/RepeatEventDropDowns";
import ReactDatePickerCommon from "components/ReactDatePickerCommon";
import constants from "../../../constants";
import { showTime } from "../Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab";
import EditOptionsModal, { editTypesVariables } from "./EditOptionsModal";
import NewConversationToast from "Messenger/pages/PatientConversation/component/NewConversationToast";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import SchedulingAssistant from "assets/images/scheduling_assistant.svg";
import SchedulingAssistantDetails from "../AddEvent/SchedulingAssistant/SchedulingAssistantDetails";
import SchedulerAssistantInfoModal from "../AddEvent/components/schedulerAssistantInfoModal";
import QuestimIcon from "assets/images/question_mark.svg";
import Text from "components/Text";
import { Suspense } from "react";
import { eventSchedulingTabStatus } from "../../../constants";
import InfoIcon from "assets/images/info_black-tooltip.svg";
import ErrorIcon from "assets/images/ico_alert.svg";
import CircleIcon from "assets/images/check_circle.svg";
import {
  currentDateDisableAccToEndTime,
  disabledDatesForCalendar,
  everyDatesCheckExceptCustomFunction,
} from "../Scheduler/components/Modals/repeatEvent.functions";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
const { repeatOptionsFrequency } = addEditEventsConst;
const EditEvent = ({ t, location, history }) => {
  const profile = useSelector((state) => state.userProfile.profile);
  const isDuplicateMode = location?.state?.duplicateEvent || false;
  const today = useMemo(
    () => moment(location?.state?.date).toDate() || moment().toDate(),
    [location?.state?.date],
  );
  const { effectiveOwnerId, getIdToCheckOwnerChange } = useAccountOwnerCommon();
  // For duplicate mode, use the original event's ownerId if available
  // Otherwise fall back to location state ownerId or profile id
  const loggedInUserId = useMemo(() => {
    if (isDuplicateMode && location?.state?.eventData?.ownerId) {
      return location.state.eventData.ownerId;
    }
    return location?.state?.ownerId ?? effectiveOwnerId ?? profile?.id;
  }, [
    isDuplicateMode,
    location?.state?.eventData?.ownerId,
    location?.state?.ownerId,
    effectiveOwnerId,
    profile?.id,
  ]);
  const [userIds, setUserIds] = useState([]);
  const [publishAsEvent, setPublishAsEvent] = useState("");
  const [nonInviteesPublish, setNonInviteesPublish] = useState("");
  const [isAutoMatically, setIsAutoMatically] = useState(false);
  const [selectOfficeForEvent, setSelectOfficeForEvent] = useState(null);
  const [eventDetail, setEventDetail] = useState({});
  const [eventOrShiftTab, setCreateOrShiftTab] = useState(false);
  const [editModalConfirmation, setEditModalConfirmation] = useState(false);

  const eventEmployeesSelected = useMemo(() => {
    return eventDetail?.eventEmployees?.flatMap((item) => {
      if (!item?.isDeletedForThisSchedulerEvent) {
        return {
          ...item,
          id: item?.id,
          schedulerEventId: item?.schedulerEventId,
          userId: item?.userId,
          officeId: item?.officeId,
          IsDeleted: false,
          isFromDetail: true,
        };
      }
      return [];
    });
  }, [eventDetail?.eventEmployees]);
  const eventKey = useMemo(
    () => ({
      eventOrShift: t(
        `accountOwner.${eventDetail?.isShift ? "shift" : "event"}Tab`,
      ).toLowerCase(),
    }),
    [eventDetail?.isShift],
  );
  const eventCapsKey = useMemo(
    () => ({
      eventOrShift: t(`accountOwner.${eventOrShiftTab ? "shift" : "event"}Tab`),
    }),
    [eventOrShiftTab],
  );
  const filteredUserIds = useMemo(
    () =>
      userIds?.filter((e) => e.IsDeleted === false || e.isDeleted === false),
    [userIds],
  );
  const userSelected = useRef(false);
  const { disbableClass, isNotDrafted } = useMemo(
    () => ({
      disbableClass: isDuplicateMode
        ? ""
        : !eventDetail?.isDraft
          ? " " + styles.make_disable
          : "",
      isNotDrafted: isDuplicateMode ? false : !eventDetail?.isDraft,
    }),
    [eventDetail?.isDraft, isDuplicateMode],
  );
  const preferredOption = useMemo(() => {
    const zeroUserCheck = filteredUserIds.length === 0;
    const values = {
      dropdown: addEditEventsConst.dropdown(t, zeroUserCheck, eventKey),
      otherOptions: addEditEventsConst.otherOptions(t, zeroUserCheck),
    };
    if (isNotDrafted) {
      return values;
    }
    if (eventDetail?.id && isNotDrafted) {
      values.dropdown.pop();
    }
    if (
      eventDetail?.id &&
      (!publishAsEvent ||
        values.dropdown.every((res) => res.id !== publishAsEvent))
    ) {
      setPublishAsEvent(values.dropdown[0].id);
    }
    if (filteredUserIds.length && !userSelected.current) {
      userSelected.current = true;
      setPublishAsEvent(values.dropdown[0].id);
    } else if (userSelected.current && !filteredUserIds.length) {
      userSelected.current = false;
    }
    if (
      eventDetail?.id &&
      (!nonInviteesPublish ||
        values.otherOptions.every((res) => res.id !== nonInviteesPublish))
    ) {
      setNonInviteesPublish(values.otherOptions[0].id);
    }
    return values;
  }, [
    filteredUserIds,
    publishAsEvent,
    nonInviteesPublish,
    eventDetail?.isDraft,
    eventDetail?.id,
    eventKey,
    isNotDrafted,
  ]);
  let { eventId } = useParams();
  eventId = decodeId(eventId);
  const goBack = (qry) => {
    if (qry) {
      history.push(constants.routes.scheduler.calendar + (qry ?? ""));
      return;
    }
    history.goBack();
  };

  if (!eventId) {
    goBack();
  }

  const repeatOptions = useMemo(
    () => addEditEventsConst.repeatedOptions(t),
    [],
  );
  const requestedDate = location?.state?.requestedDate;

  const [issaveRolesModalOpen, setIsSaveRolesModalOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [repeatedType, setRepeatedType] = useState(1);
  const [repeatedEndDate, setRepeatedEndDate] = useState(
    moment(today).add(3, "month").toDate(),
  );
  const [eventLocation, setEventLocation] = useState("");
  const [blockForPatient, setBlockForPatient] = useState(false);
  const [note, setNote] = useState("");
  const [exclude, setExclude] = useState({
    IsExcludeHoliday: false,
    IsExcludeLeave: false,
  });
  const [designationIds, setDesignationIds] = useState([]);
  const [eventTags, setEventTags] = useState([]);
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const [notifyDuration, setNotifyDuration] = useState();
  const [selectedRoleList, setSelectedRoleList] = useState([]);
  const [invitePopupOpen, setInvitePopupOpen] = useState(false);
  const [invitePopupPosition, setInvitePopupPosition] = useState({
    top: 0,
    right: 0,
  });
  const [rolePopupOpen, setRolePopupOpen] = useState(false);
  const [isSelectStaffMemberModalOpen, setIsSelectStaffMemberModalOpen] =
    useState(false);
  const [officeIdForNonInvitee, setOfficeIdForNonInvitee] = useState([]);
  const [isSelectOfficeModalOpen, setIsSelectOfficeModalOpen] = useState("");
  const [nonInvitePopup, setNonInvitePopup] = useState(false);
  const [repeatedTypeFrequency, setRepeatedTypeFrequency] = useState(1);
  const [repeatedTypeEvery, setRepeatedTypeEvery] = useState(1);
  const [schedule, setSchedule] = useState([
    today.getDay() === 0 ? 7 : today.getDay(),
  ]);
  const [selectionType, setSelectionType] = useState(true);
  const [selectedWeek, setSelectedWeek] = useState(() => {
    const startOfMonth = moment(today).clone().startOf("month");
    return moment(today).diff(startOfMonth, "weeks") + 1;
  });
  const [selectedDay, setSelectedDay] = useState(
    today.getDay() === 0 ? 7 : today.getDay(),
  );
  const [isDaySwitchOn, setIsDaySwitchOn] = useState(false);
  const [selectedSlotDate, setSelectedSlotDate] = useState([today.getDate()]);
  const [selectedMonths, setSelectedMonths] = useState([today.getMonth() + 1]);
  const [activeTab, setActiveTab] = useState(() => {
    if (
      location?.state &&
      (location.state.fromSchedulingAssistant ||
        location.state.setSchedulingAssistantTab ||
        location?.state?.fromScreen === "schedulingAssistant")
    ) {
      return eventSchedulingTabStatus.schedulingAssistant;
    }
    return eventSchedulingTabStatus.event;
  });
  const [
    isScheduleAssistantInfoModalOpen,
    setIsScheduleAssistantInfoModalOpen,
  ] = useState(false);
  const {
    eventDate,
    setEventDate,
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    isAllDayEvent,
    setIsAllDayEvent,
    endTimeError,
    handleDateTimeChange,
    startOrEndTimeValue,
  } = useEventDateTimeSync({ t, initialEventDate: today, setErrors });
  useEffect(() => {
    if (!effectiveOwnerId) return;
    if (getIdToCheckOwnerChange()) {
      if (window.history.length > 1) {
        history.goBack();
      } else {
        history.push(constants.routes.scheduler.calendar);
      }
    }
  }, [effectiveOwnerId]);
  const { isLoading: loadinStaffData, data: roleData } = useStaffDesignation();
  const createSchedulerEventMutation = useCreateUpdateSchedulerEventMutation();
  const createEventMutation = useCreateSchedulerEventMutation();
  const CreateSchedulerEventCheckingAvailabilityMutation =
    useCreateSchedulerEventCheckingAvailabilityMutation();
  const eventCheck = useMemo(
    () => !eventDetail?.isShift,
    [eventDetail?.isShift],
  );
  useEffect(() => {
    getDetails();
  }, []);
  const filteredDesignationIds = useMemo(
    () =>
      designationIds?.filter(
        (e) => e.IsDeleted === false || e.isDeleted === false,
      ),
    [designationIds],
  );
  const {
    visibilityCardForAvailability,
    conflictingData,
    anyRepeatTypeActive,
    stringValues,
  } = useMemo(() => {
    const anyRepeatTypeActive =
      repeatedType !== addEditEventsConst.repeatedOptionsValues.never;
    const conflictingData =
      CreateSchedulerEventCheckingAvailabilityMutation.data;
    return {
      visibilityCardForAvailability:
        (CreateSchedulerEventCheckingAvailabilityMutation.data ||
          anyRepeatTypeActive) &&
        filteredUserIds?.length > 0 &&
        !!startTime &&
        !!endTime,
      conflictingData,
      anyRepeatTypeActive,
      stringValues: anyRepeatTypeActive
        ? "warning"
        : conflictingData?.isConflicting
          ? "error"
          : "success",
    };
  }, [
    CreateSchedulerEventCheckingAvailabilityMutation.data,
    filteredUserIds?.length,
    startTime,
    endTime,
    repeatedType,
  ]);
  useEffect(() => {
    if (anyRepeatTypeActive) return;
    if (!filteredUserIds.length || !startTime || !endTime || !loggedInUserId)
      return;
    const timer = setTimeout(() => {
      CreateSchedulerEventCheckingAvailabilityMutation.mutate({
        Users: filteredUserIds.map((res) => ({
          UserId: res.userId,
          OfficeId: res.officeId,
        })),
        OwnerId: loggedInUserId,
        IsAllDayEvent: isAllDayEvent,
        EventDate: moment(eventDate).format("YYYY-MM-DD"),
        EventStartTime: startOrEndTimeValue(startTime, "startOf"),
        EventEndTime: startOrEndTimeValue(endTime, "endOf"),
        IsForEvent: !eventOrShiftTab,
        IsForShift: eventOrShiftTab,
      });
    }, 100);
    return () => {
      clearTimeout(timer);
    };
  }, [
    loggedInUserId,
    filteredUserIds,
    isAllDayEvent,
    startTime,
    endTime,
    anyRepeatTypeActive,
    eventDate,
  ]);

  useEffect(() => {
    if (filteredDesignationIds.length === 0) {
      setSelectedRoleList([]);
      return;
    }

    const allDesignations =
      roleData?.flatMap((data) => data.designations || []) || [];

    const matchedDesignations = filteredDesignationIds
      .map((role) =>
        allDesignations.find((item) => item.id === role?.designationsId),
      )
      .filter(Boolean);

    setSelectedRoleList(matchedDesignations);
  }, [filteredDesignationIds, roleData]);
  useEffect(() => {
    // When eventDetail is loaded or all-day toggle changes
    if (eventDetail && Object.keys(eventDetail).length > 0) {
      if (isAllDayEvent) {
        // For all-day events
        const matchingOption = notifyAttendeesOptionsForAllDayEvent(
          eventDetail?.isShift,
        ).find((option) => option.id === eventDetail.reminderBeforeInMins);
        setNotifyDuration(
          matchingOption
            ? matchingOption.id
            : notifyAttendeesOptionsForAllDayEvent(eventDetail?.isShift)[3]?.id,
        );
      } else {
        // For regular events
        const matchingOption = notifyAttendeesOptions.find(
          (option) => option.id === eventDetail.reminderBeforeInMins,
        );
        setNotifyDuration(
          matchingOption ? matchingOption.id : notifyAttendeesOptions[2]?.id,
        );
      }
    } else {
      // When creating new event (no eventDetail)
      setNotifyDuration(
        isAllDayEvent
          ? notifyAttendeesOptionsForAllDayEvent(eventDetail?.isShift)[3]?.id
          : notifyAttendeesOptions[2]?.id,
      );
    }
  }, [isAllDayEvent, eventDetail]);

  const getDetails = async () => {
    try {
      const schedularEventDate = moment(requestedDate).format("YYYY-MM-DD");
      let response = await getEventListDetails(eventId, schedularEventDate);
      const eventData = response?.data;
      if (eventData) {
        setEventDate(moment(requestedDate ?? eventData?.date).toDate());
        setTitle(eventData?.title);
        setEventLocation(eventData?.location);
        setNote(eventData?.note);
        setIsAllDayEvent(eventData?.isAllDayEvent);
        setNotifyDuration(eventData?.reminderBeforeInMins);
        setCreateOrShiftTab(eventData?.isShift);
        const publishEvent = eventData?.publishAsEvent
          ? "allowInvitees"
          : eventData?.isDraft
            ? "saveDraft"
            : "inviteesOnly";

        setPublishAsEvent(publishEvent);
        userSelected.current = true;
        const eventEmployees = [];
        for (let item of eventData?.eventEmployees) {
          if (!item?.isDeletedForThisSchedulerEvent) {
            eventEmployees.push({
              ...item,
              id: item?.id,
              schedulerEventId: item?.schedulerEventId,
              userId: item?.userId,
              officeId: item?.officeId,
              IsDeleted: false,
              isFromDetail: true,
            });
          }
        }

        setUserIds(eventEmployees);

        const eventRoles = [];
        for (let item of eventData?.eventRoles) {
          eventRoles.push({
            id: item.id,
            schedulerEventId: item?.schedulerEventId,
            designationsId: item?.designationsId,
            IsDeleted: false,
            isFromDetail: true,
          });
        }
        setDesignationIds(eventRoles);

        const tags = [];
        for (let item of eventData?.eventTags) {
          tags.push({
            id: item.id,
            schedulerEventId: item.schedulerEventId,
            title: item.title,
            IsDeleted: false,
            isFromDetail: true,
          });
        }
        setEventTags(tags);

        if (!eventData?.isAllDayEvent) {
          setStartTime(
            eventData?.startTime ? moment(eventData?.startTime) : null,
          );
          setEndTime(eventData?.endTime ? moment(eventData?.endTime) : null);
        }
        if (eventData?.repeatedEndDate) {
          setRepeatedEndDate(new Date(eventData?.repeatedEndDate));
        }
        setRepeatedType(eventData?.repeatedType);
        setBlockForPatient(eventData?.blockForPatient);
        setEventDetail(eventData);
        if (eventData?.publishedType) {
          setNonInviteesPublish(eventData?.publishedType);
        }
        if (eventData.isAutoApprove) {
          setIsAutoMatically(eventData.isAutoApprove);
        }
        // Set officeIdForNonInvitee from schedulerEventPublishedOffices
        if (
          eventData.schedulerEventPublishedOffices &&
          eventData.schedulerEventPublishedOffices.length > 0
        ) {
          const publishedOffices = eventData.schedulerEventPublishedOffices.map(
            (office) => ({
              ...office,
              id: office.officeId,
              name: office.officeName,
              externalId: office.id,
              isDeleted: false,
              isFromDetail: true,
            }),
          );
          setOfficeIdForNonInvitee(publishedOffices);
        }
        if (
          eventData?.repeatedType ===
            addEditEventsConst.repeatedOptionsValues.custom &&
          eventData?.customRepeatPattern
        ) {
          const values = eventData?.customRepeatPattern;
          setRepeatedTypeEvery(values.interval);
          setRepeatedTypeFrequency(values.unit);
          if (values?.daysOfMonth?.length) {
            setSelectedSlotDate(
              values?.daysOfMonth?.map((res) => res.day).sort(),
            );
          }
          if (values.unit === 2) {
            setSchedule(values.daysOfWeek.map((res) => res.dayOfWeek));
          }

          if (
            values.unit === repeatOptionsFrequency[2].id &&
            !values.daysOfMonth.length
          ) {
            setSelectionType(false);
          }
          if (
            [
              repeatOptionsFrequency[2].id,
              repeatOptionsFrequency[3].id,
            ].includes(values.unit) &&
            values.daysOfWeek.length
          ) {
            setSelectedDay(
              getSelectedDayValueForWeekdayOrWeekend(
                values.daysOfWeek.map((res) => res.dayOfWeek),
              ),
            );
          }
          if (values?.monthWeekNumber) {
            setSelectedWeek(values?.monthWeekNumber);
          }
          if (values?.monthsOfYear?.length) {
            setSelectedMonths(values.monthsOfYear.map((res) => res.month));
          }
          if (
            values.unit === repeatOptionsFrequency[3].id &&
            values.monthsOfYear.length > 0 &&
            values.daysOfWeek.length > 0
          ) {
            setIsDaySwitchOn(true);
          }
        }
      }
    } catch (error) {
      toast.error(error.message);
      goBack();
    }
  };

  const handleChange = (key, value) => {
    handleChangeValidation({
      key,
      value,
      errors,
      t,
      setIsAllDayEvent,
      setStartTime,
      setEndTime,
      endTime,
      updateTimeToUpcomingQuater,
      startTime,
      setErrors,
    });
  };

  const afterChanges = useRef(true);
  useEffect(() => {
    if (afterChanges.current) {
      afterChanges.current =
        !filteredUserIds.length && !filteredDesignationIds.length;
      return;
    }

    setErrors((prev) => {
      addRemoveUserOrRoleError({
        filteredUserIds,
        errorsData: prev,
        designationIds: filteredDesignationIds,
        t,
      });
      return { ...prev };
    });
  }, [filteredUserIds, filteredDesignationIds]);
  const isValidEvent = () => {
    if (
      publishAsEvent !==
      preferredOption.dropdown[preferredOption.dropdown.length - 1].id
    ) {
      return handleSubmitValidation({
        errors,
        eventCheck: !eventOrShiftTab,
        title,
        t,
        isAllDayEvent,
        startTime,
        endTime,
        filteredUserIds,
        designationIds: filteredDesignationIds,
        repeatedType,
        preferredOption,
        eventDate,
        repeatedEndDate,
        publishAsEvent,
        nonInviteesPublish,
        officeIdForNonInvitee,
        setErrors,
      });
    }
    return true;
  };
  const repeatedOptionChanged = useMemo(() => {
    return matchedBothPatternValues({
      repeatedType,
      repeatedTypeFrequency,
      repeatedTypeEvery,
      selectionType,
      schedule,
      selectedSlotDate,
      selectedWeek,
      selectedDay,
      selectedMonths,
      isDaySwitchOn,
      edit: true,
      eventDetail,
    });
  }, [
    repeatedType,
    eventDetail,
    repeatedTypeFrequency,
    repeatedTypeEvery,
    selectionType,
    schedule,
    selectedSlotDate,
    selectedWeek,
    selectedDay,
    selectedMonths,
    isDaySwitchOn,
  ]);

  const dateChanged = useMemo(() => {
    return matchedBothDatesValues({
      eventDetail,
      repeatedEndDate,
      requestedDate,
      eventDate,
    });
  }, [eventDate, repeatedEndDate, eventDetail, requestedDate]);
  const anyChangedForDate = useMemo(
    () =>
      dateChanged.startDateChanged ||
      dateChanged.endDateChanged ||
      repeatedOptionChanged,
    [repeatedOptionChanged, dateChanged],
  );

  const verifyIfUpdated = () => {
    const removedEmployeeRowIdsFromMarked = userIds.reduce((acc, curr) => {
      const isDeleted = curr?.isDeleted || curr?.IsDeleted;
      const rowId = curr?.id;
      if (isDeleted && rowId != null && rowId !== 0) {
        acc.push(rowId);
      }
      return acc;
    }, []);

    const employeeOfficeKey = (e) => `${e?.userId ?? ""}:${e?.officeId ?? ""}`;
    const originalActiveKeys = new Set(
      (eventDetail?.eventEmployees || [])
        .filter((e) => !e?.isDeletedForThisSchedulerEvent)
        .map(employeeOfficeKey),
    );
    const activeCurrentEmployees = userIds.filter(
      (curr) => !(curr?.isDeleted || curr?.IsDeleted),
    );
    const currentActiveKeys = new Set(
      activeCurrentEmployees.map(employeeOfficeKey),
    );

    const removedEmployeeRowIdsFromReplacedRows = (
      eventDetail?.eventEmployees || []
    )
      .filter((e) => !e?.isDeletedForThisSchedulerEvent)
      .filter((e) => {
        const key = employeeOfficeKey(e);
        return !currentActiveKeys.has(key) && e?.id != null && e.id !== 0;
      })
      .map((e) => e.id);

    const removedEmployeeRowIds = [
      ...new Set([
        ...removedEmployeeRowIdsFromMarked,
        ...removedEmployeeRowIdsFromReplacedRows,
      ]),
    ];

    const employeesRosterChanged =
      originalActiveKeys.size !== currentActiveKeys.size ||
      [...currentActiveKeys].some((k) => !originalActiveKeys.has(k)) ||
      [...originalActiveKeys].some((k) => !currentActiveKeys.has(k));
    const employeesRosterOrRemovalChanged =
      removedEmployeeRowIds.length > 0 || employeesRosterChanged;

    const touchedEmployeeUserIds = new Set();
    activeCurrentEmployees.forEach((e) => {
      const key = employeeOfficeKey(e);
      if (!originalActiveKeys.has(key) && e?.userId != null) {
        touchedEmployeeUserIds.add(e.userId);
      }
    });
    (eventDetail?.eventEmployees || [])
      .filter((e) => !e?.isDeletedForThisSchedulerEvent)
      .forEach((e) => {
        const key = employeeOfficeKey(e);
        if (!currentActiveKeys.has(key) && e?.userId != null) {
          touchedEmployeeUserIds.add(e.userId);
        }
      });

    let isShiftOfficeChange = false;
    if (eventDetail?.isShift) {
      const origOfficeByUserId = new Map();
      (eventDetail?.eventEmployees || [])
        .filter((e) => !e?.isDeletedForThisSchedulerEvent)
        .forEach((e) => {
          if (e?.userId != null) {
            origOfficeByUserId.set(e.userId, e.officeId);
          }
        });
      const currOfficeByUserId = new Map();
      activeCurrentEmployees.forEach((e) => {
        if (e?.userId != null) {
          currOfficeByUserId.set(e.userId, e.officeId);
        }
      });
      for (const [uid, officeId] of currOfficeByUserId) {
        if (
          origOfficeByUserId.has(uid) &&
          origOfficeByUserId.get(uid) !== officeId
        ) {
          isShiftOfficeChange = true;
          break;
        }
      }
    }

    const UpdateFlags = {
      isTitleEdit: false,
      isStartTimeEdit: false,
      isEndTimeEdit: false,
      isAllDayEventEdit: false,
      isNoteEdit: false,
      isLocationEdit: false,
      isReminderBeforeInMinsEdit: false,
      isEnterpriseEdit: false,
      isOfficeIdEdit: false,
      EmployeeIds: [],
      RemovedEmployeeRowIds: [],
      IsShiftOfficeChange: false,
      RoleIds: [],
      IsRepeatTypeChange: repeatedOptionChanged,
      IsEventDateChange: dateChanged.startDateChanged,
      IsRepeatedEndDateChange: dateChanged.endDateChanged,
      IsBlockForPatientChange: eventDetail?.blockForPatient !== blockForPatient,
      tagsIds:
        (eventTags?.length &&
          eventTags?.some((res) => {
            const isDeleted = res?.isDeleted || res?.IsDeleted;
            if (
              eventDetail?.eventTags?.some((resp) => resp.title === res.title)
            ) {
              return isDeleted;
            }
            return true;
          })) ||
        eventTags?.length !== eventDetail?.eventTags?.length,
    };

    UpdateFlags.isTitleEdit = title.trim() !== eventDetail?.title;
    UpdateFlags.isStartTimeEdit = hasTimeChanged(
      eventDetail?.startTime,
      startOrEndTimeValue(startTime, "startOf"),
    );
    UpdateFlags.isEndTimeEdit = hasTimeChanged(
      eventDetail?.endTime,
      startOrEndTimeValue(endTime, "endOf"),
    );
    UpdateFlags.isAllDayEventEdit =
      eventDetail?.isAllDayEvent !== isAllDayEvent;
    UpdateFlags.isLocationEdit = eventLocation !== eventDetail?.location;
    UpdateFlags.isNoteEdit = eventDetail?.note?.trim() !== note?.trim();
    UpdateFlags.isReminderBeforeInMinsEdit =
      notifyDuration !== eventDetail?.reminderBeforeInMins;
    UpdateFlags.EmployeeIds = employeesRosterOrRemovalChanged
      ? [...touchedEmployeeUserIds]
      : [];
    UpdateFlags.RemovedEmployeeRowIds = removedEmployeeRowIds;
    UpdateFlags.IsShiftOfficeChange = Boolean(
      eventDetail?.isShift && isShiftOfficeChange,
    );
    UpdateFlags.RoleIds = designationIds.reduce((prev, curr) => {
      const isDeleted = curr?.isDeleted || curr?.IsDeleted;
      if (
        (!isDeleted &&
          !eventDetail?.eventRoles?.some(
            (res) => res.designationsId === curr.designationsId,
          )) ||
        isDeleted
      ) {
        prev.push(curr?.designationsId);
      }
      return prev;
    }, []);

    return {
      UpdateFlags,
      changedCheck: Object.values(UpdateFlags).some((value) =>
        typeof value === "boolean" ? value : value?.length > 0,
      ),
    };
  };
  const notNeverCheck =
    repeatedType !== addEditEventsConst.repeatedOptionsValues.never;
  const saveEvent = async (confirmOpen, value = 0) => {
    const isDraft = publishAsEvent === "saveDraft";
    const isValidForm = isValidEvent();
    if (!isDraft && !isValidForm) {
      scrollToError();
      return;
    }
    if (eventOrShiftTab && !filteredUserIds.length && !confirmOpen) {
      return setIsSelectOfficeModalOpen("addOffice");
    }

    const editVerification = !isDuplicateMode ? verifyIfUpdated() : null;

    // Skip edit confirmation check for duplicate mode
    if (!isDuplicateMode) {
      const neverCheck =
        eventDetail?.repeatedType ===
        addEditEventsConst.repeatedOptionsValues.never;

      if (
        !neverCheck &&
        !value &&
        editVerification.changedCheck &&
        isNotDrafted
      ) {
        setEditModalConfirmation(true);
        return;
      }
    }

    setLoader(true);

    if (isDraft || isValidForm) {
      if (!isDuplicateMode) {
        if (
          !editVerification.changedCheck &&
          isNotDrafted &&
          (eventDetail?.isShift
            ? selectOfficeForEvent?.id === eventDetail?.officeId
            : true)
        ) {
          return goBack();
        }
      }

      const timeZone = getLocalTimeZoneCode();
      const modifiedUserIds = [...userIds];

      eventDetail?.eventEmployees?.forEach((curr) => {
        if (
          !userIds?.some(
            (res) =>
              res.userId === curr.userId && res.officeId === curr.officeId,
          )
        ) {
          modifiedUserIds.push({ ...curr, isDeleted: true, IsDeleted: true });
        }
      });

      const eventEmployeesPayload = userIds.filter(
        (e) => !(e?.IsDeleted || e?.isDeleted),
      );

      const ownerIdForDuplicate =
        isDuplicateMode && eventDetail?.ownerId
          ? eventDetail.ownerId
          : loggedInUserId;
      const params = isDuplicateMode
        ? {
            // Create API params (no SchedulerEventId, EditType, UpdateFlags, requestedDate)
            OwnerId: ownerIdForDuplicate,
            Title: title.trim(),
            Date: moment(eventDate).format("YYYY-MM-DDTHH:mm"),
            StartTime: startOrEndTimeValue(startTime, "startOf"),
            EndTime: startOrEndTimeValue(endTime, "endOf"),
            IsAllDayEvent: isAllDayEvent,
            RepeatedType: +repeatedType,
            isShift: eventOrShiftTab,
            RepeatedDay: moment(eventDate).isoWeekday(),
            RepeatedEndDate: notNeverCheck
              ? moment(repeatedEndDate).format("YYYY-MM-DDTHH:mm")
              : null,
            Location: eventLocation,
            Note: note,
            PublishAsEvent: publishAsEvent === "allowInvitees",
            isDraft,
            eventEmployees: eventEmployeesPayload,
            EventRoles: designationIds,
            EventTags: eventOrShiftTab ? [] : eventTags,
            CreatedAt: moment().format("YYYY-MM-DDTHH:mm"),
            ReminderBeforeInMins: notifyDuration,
            UtcOffsetInMinutes: moment().utcOffset(),
            BlockForPatient: eventOrShiftTab ? false : blockForPatient,
            timezoneCode: timeZone.code,
            timezoneId: timeZone.timeZoneId,
            IsExcludeLeave: notNeverCheck && (exclude?.IsExcludeLeave || false),
            IsExcludeHoliday:
              notNeverCheck && (exclude?.IsExcludeHoliday || false),
          }
        : {
            // Update API params
            SchedulerEventId: eventId,
            OwnerId: loggedInUserId,
            Title: title.trim(),
            Date: moment(
              requestedDate &&
                moment(requestedDate)
                  .startOf("day")
                  .isSame(moment(eventDate).startOf("day"))
                ? eventDetail?.date
                : eventDate,
            ).format("YYYY-MM-DDTHH:mm"),
            StartTime: startOrEndTimeValue(startTime, "startOf"),
            EndTime: startOrEndTimeValue(endTime, "endOf"),
            IsAllDayEvent: isAllDayEvent,
            RepeatedType: +repeatedType,
            RepeatedDay: moment(eventDate).isoWeekday(),
            RepeatedEndDate: notNeverCheck
              ? moment(repeatedEndDate).format("YYYY-MM-DD")
              : null,
            Location: eventLocation,
            BlockForPatient: blockForPatient,
            Note: note,
            PublishAsEvent: publishAsEvent === "allowInvitees",
            eventEmployees: eventEmployeesPayload,
            EventRoles: designationIds,
            EventTags: eventTags,
            CreatedAt: moment().format("YYYY-MM-DDTHH:mm"),
            ReminderBeforeInMins: notifyDuration,
            isDraft,
            requestedDate: moment(requestedDate).format("YYYY-MM-DDTHH:mm"),
            timezoneCode: eventDetail?.timezoneCode || timeZone.code,
            EditType: value || editTypesVariables.allEvent,
            UpdateFlags: editVerification.UpdateFlags,
          };

      if (eventOrShiftTab) {
        if (isDuplicateMode) {
          delete params.Title;
          delete params.Location;
          delete params.Note;
          params.officeId = selectOfficeForEvent?.id ?? userIds[0]?.officeId;
        } else {
          params.Title = eventDetail?.title;
          delete params.Location;
          delete params.Note;
          params.officeId = selectOfficeForEvent?.id ?? userIds[0].officeId;
        }
      } else {
        if (!isDuplicateMode) {
          params.IsAutoApprove = isAutoMatically;
        } else {
          params.IsAutoApprove = isAutoMatically;
        }
      }

      setterCustomSchduler({
        params,
        repeatedType,
        repeatedTypeFrequency,
        repeatedTypeEvery,
        selectionType,
        schedule,
        selectedSlotDate,
        selectedWeek,
        selectedDay,
        selectedMonths,
        isDaySwitchOn,
        edit: !isDuplicateMode,
        eventDetail: isDuplicateMode ? null : eventDetail,
      });
      setterPublishOffices({
        preferredOption,
        userIds: filteredUserIds,
        publishAsEvent,
        nonInviteesPublish,
        params,
        officeIdForNonInvitee,
        edit: !isDuplicateMode,
        isDraft: isDuplicateMode ? isDraft : eventDetail?.isDraft,
      });

      try {
        if (isDuplicateMode) {
          const response = await createEventMutation.mutateAsync(params);
          toast.success(t("staff.eventAdded", eventCapsKey));
          setLoader(false);
          if (response.data?.data?.firstOccurrenceDate) {
            return goBack(
              `?${showTime}=` +
                new Date(response.data?.data?.firstOccurrenceDate).valueOf(),
            );
          }
          goBack();
        } else {
          await createSchedulerEventMutation.mutateAsync(params);
          toast.success(t("staff.eventUpdated"));
          setLoader(false);
          if (anyChangedForDate) {
            history.replace(constants.routes.scheduler.calendar);
          } else {
            goBack();
          }
        }
      } catch (e) {
        toast.error(e.message);
        setLoader(false);
      }
    } else {
      scrollToError();
      setLoader(false);
    }
  };

  const scrollToError = () => {
    setTimeout(() => {
      const error = document.getElementsByClassName("error-msg");
      if (error && error.length) {
        error[0].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "start",
        });
      }
    }, 1000);
  };

  const handlePopupToggle = (event, setter) => {
    event.stopPropagation();
    setInvitePopupPosition({
      top: 40,
      left: 40,
    });
    setter((prev) => !prev);
  };

  const clearAllTags = useCallback(() => {
    setEventTags((prev) =>
      prev.map((item) => {
        item.IsDeleted = true;
        return item;
      }),
    );
  }, []);
  const staffLogin = useMemo(
    () =>
      profile?.id && profile.role.systemRole === constants.systemRoles.staff,
    [profile],
  );

  const manageTab = (tab) => {
    setActiveTab(tab);
  };
  const isCustom = useMemo(
    () => repeatedType === addEditEventsConst.repeatedOptionsValues.custom,
    [repeatedType],
  );
  const getSelectedDayNames = useCallback(() => {
    if (schedule.length === 0) return "";
    const dayMap = addEditEventsConst.dayMap;
    const sortedDays = schedule.sort((a, b) => a - b).map((val) => dayMap[val]);

    return arrayIntoString(sortedDays);
  }, [schedule]);

  const repeatMessagesDisplay = useMemo(() => {
    if (isCustom) {
      return getRepeatMessage({
        repeatedTypeEvery,
        repeatedTypeFrequency,
        repeatOptionsFrequency: addEditEventsConst.repeatOptionsFrequency,
        getSelectedDayNames,
        selectionType,
        selectedSlotDate,
        selectedWeek,
        selectedDay,
        selectedMonths,
        isDaySwitchOn,
        isFromBusySlot: false,
        isShift: eventOrShiftTab,
      });
    }
    return null;
  }, [
    repeatedTypeEvery,
    repeatedTypeFrequency,
    selectionType,
    selectedSlotDate,
    selectedWeek,
    selectedDay,
    selectedMonths,
    isDaySwitchOn,
    eventOrShiftTab,
    getSelectedDayNames,
    repeatedType,
  ]);
  const everyDatesCheckExceptCustom = useMemo(() => {
    const eventDetails = {
      repeatedType,
      date: eventDate,
      endTime: endTime,
      repeatedEndDate,
      isAllDayEvent: true,
      CustomRepeatPattern: {},
      customRepeatPattern: {},
    };
    setterCustomSchduler({
      params: eventDetails,
      repeatedType,
      repeatedTypeFrequency,
      repeatedTypeEvery,
      selectionType,
      schedule,
      selectedSlotDate,
      selectedWeek,
      selectedDay,
      selectedMonths,
      isDaySwitchOn,
    });
    if (eventDetails.CustomRepeatPattern) {
      const values = eventDetails.CustomRepeatPattern;
      eventDetails.customRepeatPattern = {
        unit: values.Unit,
        interval: values.Interval,
        daysOfWeek: values?.DaysOfWeek?.map((res) => ({
          dayOfWeek: res,
        })),
        daysOfMonth: values?.DaysOfMonth?.map((res) => ({ day: res })),
        monthsOfYear: values?.MonthsOfYear?.map((res) => ({ month: res })),
        monthWeekNumber: values?.monthWeekNumber || 1, // default value will be 1
      };
    }
    return {
      eventDetails,
      values: everyDatesCheckExceptCustomFunction(eventDetails),
    };
  }, [
    repeatedType,
    eventDate,
    repeatedEndDate,
    endTime,
    repeatedTypeFrequency,
    repeatedTypeEvery,
    selectionType,
    schedule,
    selectedSlotDate,
    selectedWeek,
    selectedDay,
    selectedMonths,
    isDaySwitchOn,
    isAllDayEvent,
  ]);

  const disabledDates = ({ date }) => {
    if (repeatedType === addEditEventsConst.repeatedOptionsValues.never) {
      return moment(date).isSame(moment(eventDate).startOf("day"));
    } else if (
      repeatedType === addEditEventsConst.repeatedOptionsValues.everyDay
    ) {
      return currentDateDisableAccToEndTime(
        everyDatesCheckExceptCustom.eventDetails,
        moment(date).format("YYYY-MM-DD"),
        moment(date).isSameOrAfter(moment(eventDate).startOf("day")),
      );
    }

    if (
      moment(date).isBefore(
        moment(everyDatesCheckExceptCustom.eventDetails.date).startOf("day"),
      )
    ) {
      return false;
    }

    return !disabledDatesForCalendar(
      everyDatesCheckExceptCustom.eventDetails,
      new Date(date),
      getDay(new Date(requestedDate)),
      everyDatesCheckExceptCustom.values.get(moment(date).format("YYYY-MM")) ??
        [],
    );
  };
  return (
    <Page
      title={
        isDuplicateMode
          ? t("accountOwner.duplicateEvent", eventCapsKey)
          : t("accountOwner.editEvent", eventCapsKey)
      }
      onBack={() => {
        goBack();
      }}
      className="scheduler-page w-100"
      actionButton={
        <button
          type="button"
          className={styles.question_btn}
          onClick={() => setIsScheduleAssistantInfoModalOpen(true)}
        >
          <img src={QuestimIcon} alt="QuestimIcon" />
          <p className="m-0">Help</p>
        </button>
      }
    >
      {(loader || loadinStaffData) && <Loader />}
      <div className="form-wrapper pt-2 mb-5 margin30">
        <div className="common-tabs scheduler-tabs">
          <Nav tabs>
            <NavItem>
              <NavLink
                className={
                  activeTab === eventSchedulingTabStatus.event ? "active" : ""
                }
                onClick={() => manageTab(eventSchedulingTabStatus.event)}
              >
                {t(`accountOwner.${eventOrShiftTab ? "shift" : "event"}Tab`)}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={
                  activeTab === eventSchedulingTabStatus.schedulingAssistant
                    ? "active"
                    : ""
                }
                onClick={() =>
                  manageTab(eventSchedulingTabStatus.schedulingAssistant)
                }
              >
                {t("scheduler.schedulingAssistant")}
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <Suspense fallback={<Loader />}>
              <TabPane tabId={1}>
                {activeTab === eventSchedulingTabStatus.event && (
                  <div className={styles.scheduling_assistant_image_wrapper}>
                    <div className={styles.scheduling_event_section}>
                      <div
                        className={!false ? styles["add-event-form"] : "w-100"}
                      >
                        <div className={styles["add-event-form"]}>
                          {eventCheck && (
                            <div className="c-field">
                              <label>{t("title")}</label>
                              <textarea
                                className="c-form-control"
                                placeholder={t("form.placeholder1", {
                                  field: t("title"),
                                })}
                                name="title"
                                maxLength="400"
                                value={title}
                                onChange={(e) => {
                                  handleChange("title", e.currentTarget.value);
                                  setTitle(e.currentTarget.value);
                                }}
                              ></textarea>
                              {errors.title && (
                                <span className="error-msg">
                                  {errors.title}
                                </span>
                              )}
                            </div>
                          )}
                          <div className="c-field">
                            <div className={" d-flex justify-content-between "}>
                              <label className={styles["c-field-label"]}>
                                <span>{t("accountOwner.staffMembers")}</span>
                              </label>
                              <span
                                className={`${styles.link_new} link-btn`}
                                onClick={() => {
                                  setIsSelectStaffMemberModalOpen(true);
                                }}
                              >
                                {t("accountOwner.selectStaff")}
                              </span>
                            </div>
                            <div className="c-form-control position-relative">
                              {filteredUserIds?.length === 0 ? (
                                <span>{t("accountOwner.noStaffSelected")}</span>
                              ) : (
                                <MoreTagsFunction
                                  value={filteredUserIds}
                                  styles={styles.link_new}
                                  clickHandler={(e) =>
                                    handlePopupToggle(e, setInvitePopupOpen)
                                  }
                                  mapFn={(member) =>
                                    member?.user?.fullName ||
                                    [
                                      member?.user?.firstName,
                                      member?.user?.lastName,
                                    ]
                                      .filter(Boolean)
                                      .join(" ")
                                  }
                                />
                              )}
                              {invitePopupOpen && (
                                <InviteesPopup
                                  position={invitePopupPosition}
                                  handleInvitePopupToggle={(e) =>
                                    handlePopupToggle(e, setInvitePopupOpen)
                                  }
                                  list={filteredUserIds}
                                  showRoleAndOffice={true}
                                  isForEvent={true}
                                />
                              )}
                            </div>
                            {errors.staffMembers && (
                              <span className="error-msg">
                                {errors.staffMembers}
                              </span>
                            )}
                            {visibilityCardForAvailability && (
                              <div className={`p-3 mt-3 cbg-${stringValues}`}>
                                <div className="d-flex align-items-start gap-xxs">
                                  <img
                                    src={
                                      anyRepeatTypeActive
                                        ? InfoIcon
                                        : conflictingData?.isConflicting
                                          ? ErrorIcon
                                          : CircleIcon
                                    }
                                    alt="warning icon"
                                  />
                                  <div>
                                    <Text
                                      size="12px"
                                      weight="500"
                                      color="#111B45"
                                    >
                                      {t(
                                        `scheduler.${stringValues}MessageForAvailability`,
                                      )}
                                    </Text>
                                    <button
                                      className="border-0 bg-transparent"
                                      onClick={() =>
                                        manageTab(
                                          eventSchedulingTabStatus.schedulingAssistant,
                                        )
                                      }
                                    >
                                      <u className="cfs-xs">
                                        {t("scheduler.viewSchedulingAssistant")}
                                      </u>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="c-field">
                            <div
                              className={" d-flex justify-content-between  "}
                            >
                              <label className={styles["c-field-label"]}>
                                {t("roles")}{" "}
                              </label>
                              <span
                                className="link-btn"
                                onClick={() => {
                                  setIsSaveRolesModalOpen(true);
                                }}
                              >
                                {t("staff.select")}
                              </span>
                            </div>
                            <div
                              className="c-form-control "
                              style={{ position: "relative" }}
                            >
                              <span>
                                {filteredDesignationIds.length === 0 ? (
                                  t("accountOwner.noRolesSelected")
                                ) : (
                                  <MoreTagsFunction
                                    value={selectedRoleList}
                                    styles={styles.link_new}
                                    clickHandler={(e) =>
                                      handlePopupToggle(e, setRolePopupOpen)
                                    }
                                    mapFn={(member) => member?.name}
                                  />
                                )}
                              </span>
                              {rolePopupOpen && (
                                <RolePopup
                                  handlePopupToggle={(e) =>
                                    handlePopupToggle(e, setRolePopupOpen)
                                  }
                                  position={invitePopupPosition}
                                  list={selectedRoleList}
                                  isForEvent={true}
                                />
                              )}
                            </div>
                            {errors?.roles && (
                              <span className="error-msg">{errors.roles}</span>
                            )}
                          </div>

                          <div className="ch-checkbox c-field all-event-checkbox">
                            <label>
                              <input
                                type="checkbox"
                                checked={isAllDayEvent}
                                onChange={() =>
                                  handleChange("allDay", !isAllDayEvent)
                                }
                              />
                              <span>
                                {t("accountOwner.allDayEvent", eventCapsKey)}
                              </span>
                            </label>
                          </div>
                          <div className="c-field">
                            <label>{t("accountOwner.date")}</label>
                            <div className="d-flex inputdate">
                              <ReactDatePickerCommon
                                dateFormat="dd-MM-yyyy"
                                className="c-form-control"
                                onChange={(e) => {
                                  setEventDate(e);
                                  // setRepeatedEndDate(moment(e).add(3, "month").toDate());
                                }}
                                // minDate={today}
                                selected={eventDate}
                              />
                            </div>
                          </div>
                          <Row>
                            <Col xs="6">
                              <div className="c-field">
                                <label>{t("start")}</label>
                                <TimePicker
                                  showSecond={false}
                                  placeholder="--"
                                  format="h:mm A"
                                  use12Hours
                                  onChange={(e) => {
                                    handleDateTimeChange("startTime", e);
                                  }}
                                  className="event-time-picker"
                                  disabled={isAllDayEvent}
                                  value={startTime}
                                  minuteStep={1}
                                />
                                {errors.startTime && (
                                  <span className="error-msg">
                                    {errors.startTime}
                                  </span>
                                )}
                              </div>
                            </Col>
                            <Col xs="6">
                              <div className="c-field">
                                <label>{t("end")}</label>
                                <TimePicker
                                  showSecond={false}
                                  placeholder="--"
                                  format="h:mm A"
                                  use12Hours
                                  onChange={(e) => {
                                    handleDateTimeChange("endTime", e);
                                  }}
                                  className={["event-time-picker"]}
                                  disabled={isAllDayEvent}
                                  value={endTime}
                                  minuteStep={1}
                                />
                                {errors.endTime && (
                                  <span className="error-msg">
                                    {errors.endTime}
                                  </span>
                                )}
                                {endTimeError && (
                                  <span className="error-msg">
                                    {endTimeError}
                                  </span>
                                )}
                              </div>
                            </Col>
                          </Row>
                          <div className="c-field">
                            <label>{t("repeat")}</label>
                            <div className="custom-dropdown-only">
                              <CustomDropdown
                                options={repeatOptions}
                                selectedOption={repeatedType}
                                selectOption={(id) => {
                                  setRepeatedType(id);
                                  if (
                                    moment(repeatedEndDate).isBefore(
                                      moment(eventDate),
                                    )
                                  ) {
                                    setRepeatedEndDate(
                                      moment(eventDate)
                                        .add(3, "month")
                                        .toDate(),
                                    );
                                  }
                                }}
                              />
                            </div>
                          </div>
                          {anyChangedForDate &&
                            eventDetail?.repeatedType !==
                              addEditEventsConst.repeatedOptionsValues
                                .never && (
                              <NewConversationToast
                                text={t(
                                  "scheduler.editRepeatEventChangeWarning",
                                )}
                                textClass=" cfs-xs"
                              />
                            )}
                          {repeatedType ===
                            addEditEventsConst.repeatedOptionsValues.custom && (
                            <RepeatEventDropDowns
                              selectionType={selectionType}
                              selectedSlotDate={selectedSlotDate}
                              selectedWeek={selectedWeek}
                              selectedDay={selectedDay}
                              eventOrShiftTab={eventOrShiftTab}
                              selectedMonths={selectedMonths}
                              isDaySwitchOn={isDaySwitchOn}
                              repeatedTypeEvery={repeatedTypeEvery}
                              repeatedTypeFrequency={repeatedTypeFrequency}
                              setSchedule={setSchedule}
                              setSelectedMonths={setSelectedMonths}
                              setSelectedSlotDate={setSelectedSlotDate}
                              schedule={schedule}
                              setRepeatedTypeEvery={setRepeatedTypeEvery}
                              setRepeatedTypeFrequency={
                                setRepeatedTypeFrequency
                              }
                              setSelectionType={setSelectionType}
                              setSelectedWeek={setSelectedWeek}
                              setSelectedDay={setSelectedDay}
                              setIsDaySwitchOn={setIsDaySwitchOn}
                            />
                          )}
                          {notNeverCheck && (
                            <div className="c-field">
                              <label>
                                {t("accountOwner.endDateRepeatedEvents", {
                                  eventOrShift: t(
                                    `accountOwner.${
                                      eventOrShiftTab ? "shift" : "event"
                                    }s`,
                                  ),
                                })}
                              </label>
                              <div className="d-flex inputdate">
                                <ReactDatePickerCommon
                                  dateFormat="dd-MM-yyyy"
                                  className="c-form-control"
                                  onChange={(e) => {
                                    setRepeatedEndDate(e);
                                  }}
                                  minDate={eventDate}
                                  selected={repeatedEndDate}
                                />
                              </div>
                              {errors?.repeatedEndDate && (
                                <span className="error-msg">
                                  {errors.repeatedEndDate}
                                </span>
                              )}
                            </div>
                          )}
                          {eventCheck && (
                            <>
                              <div className="c-field">
                                <label>{t("location")}</label>
                                <textarea
                                  className="c-form-control"
                                  placeholder={t("form.placeholder1", {
                                    field: t("location"),
                                  })}
                                  name="location"
                                  maxLength="400"
                                  value={eventLocation}
                                  onChange={(e) => {
                                    handleChange(
                                      "eventLocation",
                                      e.currentTarget.value,
                                    );
                                    setEventLocation(e.currentTarget.value);
                                  }}
                                ></textarea>
                              </div>

                              <div className="c-field">
                                <label className="mb-3">
                                  {t("accountOwner.blockTimeslotAallDoctors")}
                                </label>
                                <div className="ch-radio">
                                  <label
                                    className="mr-5"
                                    onClick={() => setBlockForPatient(true)}
                                  >
                                    <input
                                      type="radio"
                                      name="blockTimeslotAallDoctors"
                                      checked={blockForPatient}
                                    />
                                    <span> Yes </span>
                                  </label>

                                  <label
                                    onClick={() => setBlockForPatient(false)}
                                  >
                                    <input
                                      type="radio"
                                      name="blockTimeslotAallDoctors"
                                      checked={!blockForPatient}
                                    />
                                    <span>No</span>
                                  </label>
                                </div>
                              </div>

                              <div className="c-field">
                                <label>{t("accountOwner.notes")}</label>
                                <textarea
                                  className="c-form-control"
                                  placeholder={t("form.placeholder1", {
                                    field: t("accountOwner.notes"),
                                  })}
                                  name="Notes"
                                  maxLength="1000"
                                  value={note}
                                  onChange={(e) => {
                                    if (testRegexCheck(e.currentTarget.value)) {
                                      handleChange(
                                        "note",
                                        e.currentTarget.value,
                                      );
                                      setNote(e.currentTarget.value);
                                    }
                                  }}
                                ></textarea>
                                {errors.note && (
                                  <span className="error-msg">
                                    {errors.note}
                                  </span>
                                )}
                              </div>
                              <div className="c-field">
                                <div
                                  className={
                                    " d-flex justify-content-between  "
                                  }
                                >
                                  <label className="c-field-label">
                                    {t("accountOwner.tags")}
                                  </label>
                                  {eventTags.filter(
                                    (e) => e.IsDeleted === false,
                                  )?.length > 0 && (
                                    <span
                                      className="link-btn"
                                      type="button"
                                      data-testid="button-clearAll"
                                      onClick={() => {
                                        clearAllTags();
                                      }}
                                    >
                                      Clear all
                                    </span>
                                  )}
                                </div>

                                <CustomInputTag
                                  tagslist={eventTags}
                                  eventId={eventId}
                                  setTagslist={(value) => setEventTags(value)}
                                />
                              </div>
                            </>
                          )}
                          <div className="c-field">
                            <label>
                              {t("scheduler.notifyAttendees", eventCapsKey)}
                            </label>
                            <div className="custom-dropdown-only">
                              <CustomDropdown
                                options={
                                  isAllDayEvent
                                    ? notifyAttendeesOptionsForAllDayEvent(
                                        eventDetail?.isShift,
                                      )
                                    : notifyAttendeesOptions
                                }
                                selectedOption={notifyDuration}
                                selectOption={(id) => {
                                  setNotifyDuration(id);
                                }}
                                matchWithOther={[0]}
                              />
                            </div>
                          </div>

                          <div className={"c-field " + disbableClass}>
                            <label>
                              {t(
                                "accountOwner.publishEventHeadingSelection",
                                eventCapsKey,
                              )}
                            </label>
                            <div className="custom-dropdown-only">
                              <CustomDropdown
                                options={preferredOption.dropdown}
                                selectedOption={publishAsEvent}
                                disabled={isNotDrafted}
                                selectOption={(id) => {
                                  setPublishAsEvent(id);
                                }}
                              />
                            </div>
                          </div>

                          {preferredOption.dropdown[
                            isNotDrafted && !filteredUserIds?.length
                              ? 0
                              : filteredUserIds.length > 0
                                ? 1
                                : 0
                          ].id === publishAsEvent && (
                            <div className={styles["other-options-main"]}>
                              <div
                                className={"c-field mb-0 pb-3" + disbableClass}
                              >
                                <label>
                                  {t("scheduler.whoElseCanJoin", eventKey)}
                                </label>
                              </div>
                              {preferredOption.otherOptions?.map(
                                (otherOption, ind, currArr) => {
                                  const selected =
                                    otherOption.id === nonInviteesPublish;
                                  if (ind === currArr.length - 1) {
                                    return (
                                      <div
                                        className={
                                          "c-field mb-0 " +
                                          (!disbableClass && selected
                                            ? " " + styles["checked-field"]
                                            : "")
                                        }
                                        key={otherOption.title}
                                      >
                                        <div
                                          className={
                                            "d-flex justify-content-between align-items-center ch-radio" +
                                            disbableClass
                                          }
                                        >
                                          <label
                                            className={styles["c-field-label"]}
                                          >
                                            <input
                                              type="radio"
                                              name={otherOption.id}
                                              checked={selected}
                                              disabled={isNotDrafted}
                                              onChange={() =>
                                                setNonInviteesPublish(
                                                  otherOption.id,
                                                )
                                              }
                                            />
                                            <span>{otherOption.title}</span>
                                          </label>

                                          <small
                                            className={`${
                                              styles.link_new
                                            } link-btn ${
                                              !selected ? "disabled" : ""
                                            }`}
                                            onClick={() => {
                                              if (
                                                selected &&
                                                (eventDetail?.isDraft ||
                                                  isDuplicateMode)
                                              ) {
                                                setIsSelectOfficeModalOpen(
                                                  "select",
                                                );
                                              }
                                            }}
                                          >
                                            {t("accountOwner.selectOffices")}
                                          </small>
                                        </div>

                                        <div
                                          className={
                                            "c-form-control " + styles.link_new
                                          }
                                          style={{
                                            position: "relative",
                                          }}
                                        >
                                          {officeIdForNonInvitee?.length ===
                                          0 ? (
                                            <small
                                              className={`${
                                                !selected ? "disabled" : ""
                                              }`}
                                            >
                                              {t(
                                                "accountOwner.noOfficeSelected",
                                              )}
                                            </small>
                                          ) : (
                                            <MoreTagsFunction
                                              value={officeIdForNonInvitee}
                                              styles={styles.link_new_btn}
                                              clickHandler={(e) =>
                                                handlePopupToggle(
                                                  e,
                                                  setNonInvitePopup,
                                                )
                                              }
                                              mapFn={(member) => member?.name}
                                            />
                                          )}

                                          {nonInvitePopup && selected && (
                                            <InviteesPopup
                                              position={invitePopupPosition}
                                              handleInvitePopupToggle={(e) =>
                                                handlePopupToggle(
                                                  e,
                                                  setNonInvitePopup,
                                                )
                                              }
                                              list={officeIdForNonInvitee}
                                              showRoleAndOffice={false}
                                              isForEvent={true}
                                              onlyOfffice
                                              isfromBusySlot
                                            />
                                          )}
                                          {errors.nonInvitee && (
                                            <small className="error-msg">
                                              {errors.nonInvitee}
                                            </small>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  }

                                  return (
                                    <div
                                      className={
                                        "ch-radio position-relative" +
                                        disbableClass
                                      }
                                    >
                                      <label
                                        className={
                                          styles["c-field-label"] +
                                          " w-100 " +
                                          styles["radio_btn_border"] +
                                          (!disbableClass && selected
                                            ? " " + styles["checked-field"]
                                            : "")
                                        }
                                      >
                                        <input
                                          type="radio"
                                          name={otherOption.id}
                                          checked={
                                            otherOption.id ===
                                            nonInviteesPublish
                                          }
                                          disabled={isNotDrafted}
                                          onChange={() => {
                                            setNonInviteesPublish(
                                              otherOption.id,
                                            );
                                            if (officeIdForNonInvitee?.length) {
                                              setOfficeIdForNonInvitee([]);
                                            }
                                          }}
                                        />
                                        <span>{otherOption.title}</span>
                                        {filteredUserIds.length > 0 &&
                                          !ind &&
                                          selected && (
                                            <div
                                              className={
                                                styles["office-names"] +
                                                " remove_radio_from_span mt-2 cfs-sm"
                                              }
                                            >
                                              <MoreTagsFunction
                                                value={Array.from(
                                                  new Map(
                                                    filteredUserIds.map(
                                                      (user) => [
                                                        user.office.id,
                                                        user.office,
                                                      ],
                                                    ),
                                                  ).values(),
                                                )}
                                                styles={styles.link_new_btn}
                                                mapFn={(office) => office?.name}
                                                clickHandler={(e) =>
                                                  handlePopupToggle(
                                                    e,
                                                    setNonInvitePopup,
                                                  )
                                                }
                                              />
                                            </div>
                                          )}
                                      </label>
                                      {nonInvitePopup && selected && (
                                        <InviteesPopup
                                          position={invitePopupPosition}
                                          handleInvitePopupToggle={(e) =>
                                            handlePopupToggle(
                                              e,
                                              setNonInvitePopup,
                                            )
                                          }
                                          list={Array.from(
                                            new Map(
                                              filteredUserIds.map((user) => [
                                                user.office.id,
                                                user.office,
                                              ]),
                                            ).values(),
                                          )}
                                          showRoleAndOffice={false}
                                          isForEvent={true}
                                          onlyOfffice
                                          isfromBusySlot
                                        />
                                      )}
                                    </div>
                                  );
                                },
                              )}
                            </div>
                          )}

                          <div className="add-event-btn-box margin30">
                            <button
                              className="button button-round button-shadow mr-4"
                              onClick={() => saveEvent()}
                            >
                              {isDuplicateMode
                                ? t("accountOwner.duplicateEvent", eventCapsKey)
                                : t("accountOwner.UpdateEvent", eventCapsKey)}
                            </button>
                            <button
                              className="button button-round button-dark button-border"
                              title={t("cancel")}
                              onClick={() => {
                                goBack();
                              }}
                            >
                              {t("cancel")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.scheduling_right_section}>
                      <div className={styles.image_text_wrap}>
                        <img
                          src={SchedulingAssistant}
                          alt="scheduling assistant"
                          className={styles.scheduling_assistant_img}
                        />
                        <Text size="20px" weight="500" color="#111B45">
                          Need to find a time that works for everyone?
                        </Text>
                        <Text size="20px" weight="500" color="#111B45">
                          Switch to the 'Scheduling Assistant' tab at the top
                          right to get started.
                        </Text>
                      </div>
                    </div>
                  </div>
                )}
              </TabPane>
              <TabPane tabId={2}>
                {activeTab === eventSchedulingTabStatus.schedulingAssistant && (
                  <SchedulingAssistantDetails
                    eventDate={eventDate}
                    setEventDate={setEventDate}
                    startTime={startTime}
                    setStartTime={setStartTime}
                    endTime={endTime}
                    setEndTime={setEndTime}
                    isAllDayEvent={isAllDayEvent}
                    setIsAllDayEvent={setIsAllDayEvent}
                    endTimeError={endTimeError}
                    handleDateTimeChange={handleDateTimeChange}
                    errors={errors}
                    eventOrShiftTab={eventOrShiftTab}
                    selectedStaff={filteredUserIds}
                    setSelectedStaff={setUserIds}
                    ownerId={loggedInUserId}
                    manageTab={manageTab}
                    eventSchedulingTabStatus={eventSchedulingTabStatus}
                    options={repeatOptions}
                    selectedOption={repeatedType}
                    disabledDates={disabledDates}
                    repeatMessagesDisplay={repeatMessagesDisplay}
                    selectOption={(id) => {
                      setRepeatedType(id);
                    }}
                    prevSelectedValues={{
                      schedule,
                      selectedMonths,
                      selectedSlotDate,
                      repeatedTypeEvery,
                      repeatedTypeFrequency,
                      selectionType,
                      selectedWeek,
                      selectedDay,
                      isDaySwitchOn,
                    }}
                    setRepeatTypeValues={(values) => {
                      setSchedule(values.schedule);
                      setSelectedMonths(values.selectedMonths);
                      setSelectedSlotDate(values.selectedSlotDate);
                      setRepeatedTypeEvery(values.repeatedTypeEvery);
                      setRepeatedTypeFrequency(values.repeatedTypeFrequency);
                      setSelectionType(values.selectionType);
                      setSelectedWeek(values.selectedWeek);
                      setSelectedDay(values.selectedDay);
                      setIsDaySwitchOn(values.isDaySwitchOn);
                    }}
                  />
                )}
              </TabPane>
            </Suspense>
          </TabContent>
        </div>
      </div>

      {issaveRolesModalOpen && (
        <AddRolesModal
          issaveRolesModalOpen={issaveRolesModalOpen}
          setIsSaveRolesModalOpen={setIsSaveRolesModalOpen}
          designationIds={designationIds}
          setDesignationIds={setDesignationIds}
          userRoles={roleData ? roleData : []}
          eventId={eventId}
        />
      )}
      {isSelectStaffMemberModalOpen && (
        <SelectStaffMemberModal
          isOpen={isSelectStaffMemberModalOpen}
          closeStepOneModal={setIsSelectStaffMemberModalOpen}
          ownerId={loggedInUserId}
          setMemberIds={setUserIds}
          memberIds={userIds}
          forEdit={true}
          eventOrShiftTab={eventOrShiftTab}
          canAddShift={staffLogin && eventOrShiftTab}
          IsOwnerInclude={true}
          eventEmployeesSelected={eventEmployeesSelected}
        />
      )}
      {!!isSelectOfficeModalOpen && (
        <SelectOfficeModal
          isOpen={isSelectOfficeModalOpen}
          closeStepOneModal={setIsSelectOfficeModalOpen}
          ownerId={loggedInUserId}
          canAddShift={staffLogin && eventOrShiftTab}
          fromSelectOffice={isSelectOfficeModalOpen === "select"}
          setMemberIds={(value) => {
            if (errors.nonInvitee && value?.length) {
              setErrors((prev) => {
                delete prev.nonInvitee;
                return {
                  ...prev,
                };
              });
            }
            if (
              eventOrShiftTab &&
              !selectOfficeForEvent &&
              value?.length === 1
            ) {
              setSelectOfficeForEvent(value[0]);
            }
            setOfficeIdForNonInvitee(value);
          }}
          memberIds={officeIdForNonInvitee}
          forEdit={true}
          selectOfficeForEvent={selectOfficeForEvent}
          setSelectOfficeForEvent={setSelectOfficeForEvent}
          eventKey={eventKey}
          eventCapsKey={eventCapsKey}
          eventDetail={eventDetail}
          callConfirm={() => {
            setIsSelectOfficeModalOpen("");
            saveEvent(true);
          }}
        />
      )}
      {editModalConfirmation && (
        <EditOptionsModal
          isOpen={editModalConfirmation}
          closeStepOneModal={setEditModalConfirmation}
          loader={loader}
          eventKey={eventKey}
          eventOrShiftTab={eventOrShiftTab}
          repeatedOptionChanged={repeatedOptionChanged}
          handleConfirm={(value) => {
            saveEvent(true, value);
          }}
        />
      )}
      {isScheduleAssistantInfoModalOpen && (
        <SchedulerAssistantInfoModal
          isOpen={isScheduleAssistantInfoModalOpen}
          onClose={setIsScheduleAssistantInfoModalOpen}
          isShift={eventOrShiftTab}
          eventKey={eventKey}
          activeTab={activeTab}
        />
      )}
    </Page>
  );
};

export default withTranslation()(EditEvent);
